import { Coin } from './../../models/Coin';

import { LiveSignal } from './../../models/Signal';
import { Component, Input } from '@angular/core';

@Component({
	selector: 'signal-view-details',
	templateUrl: 'signal-view-details.html'
})
export class SignalViewDetailsComponent {

	@Input('signal') signal: LiveSignal;
	@Input('coin') coin: Coin;
	constructor() {

	}

	ngOnInit() {
	}

	getGainClass(): string {
		if (!this.signal) return '';
		let gain = this.signal.getCurrentPercentGain();
		if (gain > 0) {
			return 'target';
		} else if (gain < 0) {
			return 'stop';
		} else {
			return '';
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/signal-view-details/signal-view-details.ts